// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
//import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAfCD_baCVn26uqy0vYouPXJwGPmjKarSU",
  authDomain: "stitchsome-5c8a4.firebaseapp.com",
  projectId: "stitchsome-5c8a4",
  storageBucket: "stitchsome-5c8a4.appspot.com",
  messagingSenderId: "881965758513",
  appId: "1:881965758513:web:9d42b2b82d69cc928efd10",
  measurementId: "G-CQ1WDZGR7C"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
//const analytics = getAnalytics(app);
